import { mask } from 'remask';

export function unmaskCnpj(value: string) {
  if (!value) return '';
  const cep = ['99999999999999'];

  return mask(value, cep);
}
